<script lang="tsx">
import { defineComponent, computed } from 'vue';
// import { UserInfo } from '@/components/UserInfo';
import { useAppStore } from '@/store/modules/app';
import { useDesign } from '@/hooks/web/useDesign';
import Breadcrumb from './Breadcrumb.vue';
import UserMenu from './userMenu.vue';
import ThemeSwitch from './ThemeSwitch.vue';
const { getPrefixCls, variables } = useDesign();
const prefixCls = getPrefixCls('tool-header');

export default defineComponent({
  name: 'ToolHeader',
  setup() {
    const appStore = useAppStore();

    // 面包屑
    const breadcrumb = computed(() => appStore.getBreadcrumb);

    const collapse = computed(() => appStore.getCollapse);

    // 布局
    const layout = computed(() => appStore.getLayout);
    const onCollapseChange = () => {
      appStore.setCollapse(!collapse.value);
    };
    return () => (
      <div id={`${variables.namespace}-tool-header`} class={[prefixCls, ' flex items-center justify-between h-full']}>
        {layout.value !== 'top' ? (
          <div class='flex items-center h-full'>
            <i
              class={`iconfont mr-2 cursor-pointer ${collapse.value ? 'icon-zuosuojin' : 'icon-yousuojin'}`}
              onClick={onCollapseChange}
            ></i>
            {breadcrumb.value ? <Breadcrumb class='<md:hidden'></Breadcrumb> : undefined}
          </div>
        ) : undefined}
        <div class='flex items-center h-full'>
          <ThemeSwitch></ThemeSwitch>
          <UserMenu></UserMenu>
        </div>
      </div>
    );
  },
});
</script>

<style lang="less" scoped>
@prefix-cls: ~'@{adminNamespace}-tool-header';

.@{prefix-cls} {
  transition: left var(--transition-time-02);
}
</style>
